import React from "react";
import imageProject from "../../img/project.jpg";
// import ProjectContainer from "./ProjectContainer";
import { Link } from "react-router-dom";

export default function ProjectCard({ projects }) {
  var content = "Loading...";
  // var project = `{"project_id":13,"project_title":"Stena","roles":[{"role_id":1,"role_name":"QA","people":[{"people_id":2,"people_name":"Jana Antic","seniority":{"seniority_id":3,"seniority_title":"Intermediate"},"technologies":[]},{"people_id":1,"people_name":"Aleksandar Pavlovic","seniority":{"seniority_id":1,"seniority_title":"Intern"},"technologies":[{"technology_id":3,"technology_title":"Javascript"},{"technology_id":101,"technology_title":"Java"},{"technology_id":109,"technology_title":"PHP"}]},{"people_id":23,"people_name":"Sandra Jeremenkovic","seniority":{"seniority_id":2,"seniority_title":"Junior"},"technologies":[{"technology_id":101,"technology_title":"Java"}]},{"people_id":22,"people_name":"Milos Decov","seniority":{"seniority_id":3,"seniority_title":"Intermediate"},"technologies":[{"technology_id":110,"technology_title":"Photoshop"},{"technology_id":109,"technology_title":"PHP"},{"technology_id":7,"technology_title":"Product Owner"},{"technology_id":101,"technology_title":"Java"}]}]},{"role_id":3,"role_name":"Frontend","people":[{"people_id":19,"people_name":"Goran Pantic","seniority":{"seniority_id":4,"seniority_title":"Senior"},"technologies":[{"technology_id":3,"technology_title":"Javascript"}]},{"people_id":20,"people_name":"Pavle Lekic","seniority":{"seniority_id":4,"seniority_title":"Senior"},"technologies":[{"technology_id":3,"technology_title":"Javascript"}]},{"people_id":21,"people_name":"Mladen Karadzic","seniority":{"seniority_id":3,"seniority_title":"Intermediate"},"technologies":[{"technology_id":3,"technology_title":"Javascript"}]}]},{"role_id":11,"role_name":"Design","people":[{"people_id":17,"people_name":"Andrija Stojkovic","seniority":{"seniority_id":4,"seniority_title":"Senior"},"technologies":[{"technology_id":110,"technology_title":"Photoshop"}]},{"people_id":18,"people_name":"Mladen Misic","seniority":{"seniority_id":3,"seniority_title":"Intermediate"},"technologies":[{"technology_id":110,"technology_title":"Photoshop"}]}]},{"role_id":4,"role_name":"DevOps","people":[{"people_id":16,"people_name":"Nikola Zlatkovic","seniority":{"seniority_id":3,"seniority_title":"Intermediate"},"technologies":[{"technology_id":4,"technology_title":".NET"}]}]},{"role_id":2,"role_name":"Backend","people":[{"people_id":5,"people_name":"Dalibor Dragisic","seniority":{"seniority_id":4,"seniority_title":"Senior"},"technologies":[{"technology_id":4,"technology_title":".NET"}]},{"people_id":12,"people_name":"Marko Milosevic","seniority":{"seniority_id":4,"seniority_title":"Senior"},"technologies":[{"technology_id":4,"technology_title":".NET"}]},{"people_id":13,"people_name":"Ivica Pesic","seniority":{"seniority_id":4,"seniority_title":"Senior"},"technologies":[{"technology_id":4,"technology_title":".NET"}]},{"people_id":14,"people_name":"Stefan Milivojevic","seniority":{"seniority_id":3,"seniority_title":"Intermediate"},"technologies":[{"technology_id":4,"technology_title":".NET"}]},{"people_id":15,"people_name":"Milan Licanin","seniority":{"seniority_id":3,"seniority_title":"Intermediate"},"technologies":[{"technology_id":4,"technology_title":".NET"}]}]},{"role_id":5,"role_name":"Management","people":[{"people_id":3,"people_name":"Slavisa Djokic","seniority":{"seniority_id":4,"seniority_title":"Senior"},"technologies":[{"technology_id":6,"technology_title":"Project Management"}]},{"people_id":4,"people_name":"Gabriela Mate","seniority":{"seniority_id":4,"seniority_title":"Senior"},"technologies":[{"technology_id":7,"technology_title":"Product Owner"}]}]}]}`;
  // var projectJson = JSON.parse(project);
  if (projects && projects.length > 0) {
    content = (
      <div className='portrait-grid'>
        {projects &&
          projects.map((project, index) => (
            <span key={index}>
              <Link className='preview-card' to={`/edit-project/${project.id}`}>
                <div className='preview-card'>
                  <div className='preview-card-title'>
                    <div className='preview-card-title-value'>{project.title}</div>
                  </div>
                  <div className='preview-card-body'>
                    <div className='preview-card-body--items'>
                      <div className='preview-card-body--items-single'>
                        <div className='preview-card-body--items-single-title'>Teams:</div>
                        <div className='preview-card-body--items-single-value'>
                          {project.teams ? project.teams.length : 0}
                        </div>
                      </div>
                    </div>
                    <div className='preview-card-body--items'>
                      <div className='preview-card-body--items-single'>
                        <div className='preview-card-body--items-single-title'>People:</div>
                        <div className='preview-card-body--items-single-value'>{project.people_count}</div>
                      </div>
                    </div>
                    <div className='preview-card-body--items'>
                      <div className='preview-card-body--items-single'>
                        <div className='preview-card-body--items-single-title'>Seniorities:</div>
                        <div className='preview-card-body--items-single-value'>{project.seniority_count}</div>
                      </div>
                    </div>
                    <div className='preview-card-body--items'>
                      <div className='preview-card-body--items-single'>
                        <div className='preview-card-body--items-single-short'>
                          <div className='preview-card-body--items-single-short-title'>Technologies:</div>
                          <div className='preview-card-body--items-single-short-value'>{project.technology_count}</div>
                        </div>
                      </div>
                    </div>
                    <div
                      className='preview-card-body--items'
                      onClick={(e) => e.preventDefault()}
                      data-toggle='modal'
                      data-target={`#myModal-${index}`}
                    >
                      <div className='preview-card-body--items-single-preview'>
                        <div className='preview-card-body--items-single-preview-title'>Preview</div>
                        <div className='preview-card-body--items-single-preview-value'>
                          <i className='fas fa-eye'></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>

              <div id={`myModal-${index}`} className='modal fade' role='dialog'>
                <div className='modal-dialog'>
                  {/* <!-- Modal content--> */}
                  <div className='modal-content'>
                    <div className='modal-header'>
                      <h4 className='modal-titles'>Project Preview</h4>
                      <button type='button' className='close' data-dismiss='modal'>
                        &times;
                      </button>
                    </div>
                    <div className='modal-body'>
                      <React.Fragment key={1}>
                        {/* <div className='project-container'> */}
                        <div className='project-container-top'>
                          <div className='project-container-top-image'>
                            <div className='fixed-ratio-div'>
                              <img
                                className='card-img-top rounded-circle'
                                src={project.image ? project.image : imageProject}
                                alt=''
                                title={"title"}
                              />
                            </div>
                          </div>
                          <div className='project-container-top-title'>{project && project.title}</div>
                        </div>

                        <div className='project-container-bottom'>
                          {project &&
                            project.teams &&
                            project.teams.map((team, teamIndex) => (
                              <div className='project-container-bottom--teams' key={teamIndex}>
                                <React.Fragment key={teamIndex}>
                                  <div className='project-container-bottom--teams-title'>{team.title}</div>
                                  {team.people &&
                                    team.people.map((person, personIndex) => (
                                      <React.Fragment key={personIndex}>
                                        <div className='project-container-bottom--teams-people'>
                                          <div className='project-container-bottom--teams-people--person'>
                                            <div className='project-container-bottom--teams-people--person-name'>
                                              {person && person.name ? person.name : ""}
                                            </div>
                                            <div className='project-container-bottom--teams-people--person-seniority'>
                                              {person.seniority && person.seniority.title
                                                ? `Seniority: ${person.seniority.title}`
                                                : ""}
                                            </div>
                                            <div className='project-container-bottom--teams-people--person-technologies'>
                                              {person.technologies && person.technologies.length > 0
                                                ? `Technologies: `
                                                : ""}
                                              {person.technologies &&
                                                person.technologies.map((technology, technologyIndex) => (
                                                  <React.Fragment key={technologyIndex}>
                                                    {technology.title}
                                                    {person.technologies.length - 1 > technologyIndex ? `, ` : ``}
                                                  </React.Fragment>
                                                ))}
                                            </div>
                                          </div>
                                        </div>
                                      </React.Fragment>
                                    ))}
                                </React.Fragment>
                              </div>
                            ))}
                        </div>
                        {/* </div> */}
                      </React.Fragment>
                    </div>
                    <div className='modal-footer'>
                      <button type='button' className='btn btn-default' data-dismiss='modal'>
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </span>
          ))}
      </div>
    );
  } else {
    content = <div className='no-content'>There are no projects created.</div>;
  }
  return <div>{content}</div>;
}
